const POSTER_FLOOR_ACTIVE_LABEL_ID = 'poster-floor-active-label-id'
const FLOOR_NAME_TYPES = {
    FLOOR_AND_BUILDING_INDEX: 'floor_and_building_index',
    FLOOR_NAME: 'floor_name',
    FLOOR_NAME_FROM_FLOOR_META: 'floor_name_from_floor_meta',
    FLOOR_AND_BUILDING: 'floor_and_building',
    LOCATION_AND_FLOOR: 'location_and_floor'

}
export {
    FLOOR_NAME_TYPES,
    POSTER_FLOOR_ACTIVE_LABEL_ID
}